<!-- 记工流水列表 -->
<template>
  <div class="content" v-loading="loading">
    <div class="select-time">
      选择月份：
      <el-select
        @change="getList()"
        v-model="workYear"
        placeholder="请选择年份"
        style="width: 100px;margin-right: 10px"
      >
        <el-option
          v-for="item in years"
          :key="item"
          :label="item + '年'"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-select
        @change="getList()"
        v-model="workMonth"
        placeholder="请选择月份"
        style="width: 100px"
      >
        <el-option
          v-for="item in months"
          :key="item"
          :label="item + '月'"
          :value="item"
        >
        </el-option>
      </el-select>
    </div>
    <BaseEmptyData isDetail v-if="!list.length"></BaseEmptyData>
    <div class="list">
      <div
        class="card"
        v-for="(item, index) in list"
        :key="index"
      >
        <header class="color666">{{ formateDate(item.recordDate) }}</header>
        <div class="card-content">
          <div class="flex_jc_sb card_item">
            <div>
              <span class="salary" v-if="Number(item.salary)">￥{{ Number(item.salary).toFixed(2) }} 元</span>
              <span class="color333">在{{ item.projectName }}记了一笔{{ item.recordType === '1' ? '点工' : '包工' }}</span>
              <span v-if="$route.query.type==='2'"> ({{ item.workerName }})</span>
            </div>
            <div>
              <WorkPointDetail :project="item" v-if="item.recordType==='1'"></WorkPointDetail>
              <WorkBaoDetail :project="item" v-if="item.recordType==='2'"></WorkBaoDetail>
            </div>
          </div>
          <el-row class="card_item" v-if="item.recordType === '1'">
            <el-col :span="12"><span class="color666">上班：</span><span class="color333">{{ formateWorkDuration(item.workType,item.workDuration) }}</span></el-col>
            <el-col :span="12"><span class="color666">加班：</span><span class="color333">{{ Number(item.workOvertimeDuration) ? item.workOvertimeDuration+'小时':'无加班' }}</span></el-col>
          </el-row>
          <div style="display:flex;margin-bottom:20px" class="color333" v-if="item.remark">
            <div style="width:3em" class="color666">备注：</div>
            <div style="flex:1">{{ item.remark }}</div>
          </div>
          <div style="display:flex;margin-bottom:20px" class="color333" v-if="item.picture">
            <div style="width:3em"></div>
            <div style="flex:1" v-if="item.picture">
              <el-image
                class="pics"
                v-for="(item, index) in item.picture.split(',')"
                :src="item"
                :key="index"
                :preview-src-list="[item]"
              /></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {api} from '@/api/apiRecord.js'
import calendar from '@/components/Calendar/yingli.js'

export default {
  name: "water",
  components: {
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"), // 无数据组件
    WorkPointDetail: () =>import("./workPointDetail"), // 点工 详情弹窗
    WorkBaoDetail: () =>import("./workBaoDetail") // 包工 详情弹窗
  },
  props: {
    project: {
      type: [Object, undefined],
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      workYear: "", // 选中的年份
      workMonth: "", // 选中的月份
      years: [], // 年份列表
      months: [], // 月份列表
      list: [],
      tprojectNo:'',
      loading:false
    }
  },
  mounted() {
    this.workYear = new Date().getFullYear()
    this.workMonth = new Date().getMonth() + 1
    this.createYears()
  },
  methods: {
    createYears() {
      for (let i = 1970; i <= this.workYear; i++) {
        this.years.push(i)
      }
      for (let i = 1; i < 13; i++) {
        this.months.push(i)
      }
    },
    async getList(projectNo) {
      this.loading=true
      if(projectNo || this.project.projectNo)this.tprojectNo=projectNo || this.project.projectNo
      const params = {
        month: `0${this.workMonth}`.substr(-2),
        projectNo: this.tprojectNo,
        year: String(this.workYear),
        type: this.$route.query.type // 类型(1:个人记工,2:班组记工3:个人记账,,4:班组记账)
      }
      const res = await api.workRecords(params)
      if (res.data.code === 200) {
        this.list = res.data.data
      }
      this.loading=false
    },
    // 格式化上班时长显示
    formateWorkDuration(type,val){
      switch (type) {
        case "1":
          return val + '个工'
          break;
        case "2":
          return val + '个工'
          break;
        case "3":
          return '休息'
          break;
        case "4":
          return val + '小时'
          break;
        default:
          return '休息'
          break;
      }
    },
    // 列表标题日期，国历转农历
    formateDate(v){
      const date = v.split('-')
      const yinli = calendar.solar2lunar(date[0], date[1], date[2])
      return `${date[0]}年${date[1]}月${date[2]}日 (${yinli.IMonthCn}${yinli.IDayCn})`
    }
  }
}
</script>

<style lang="scss" scoped>
.content {


  .select-time {
    margin: 10px 0;
    padding: 0 20px;
    height: 40px;
  }

  .list {
    padding: 0 20px;
    max-height: 557px;
    overflow-y: auto;

    .card {
      border: 1px solid #E4E7ED;
      border-radius: 2px;
      margin-bottom: 10px;

      header {
        padding: 0 10px;
        line-height: 40px;
        background: #F5F7FA;
        font-size: 14px;
      }

      .card-content {
        padding: 20px 10px 0;

        .salary {
          color: #FF6600;
          margin-right: 20px;
          font-size: 16px;
        }

        .pics {
          margin-right: 10px;
          width: 70px;
          height: 70px;
        }
      }
    }
  }
}

.color666 {
  color: #666666;
}
.color333{
  color: #333333;
}
.card_item {
  margin-bottom: 15px;
}
</style>
